import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes, State } from "./types";
import { IChatGroup, IChatOptions } from "@deltasge/marauders-map";

const INITIAL_STATE: State = {
  chat: 0,
  geral: 0,
  mensagens: 0,
  unreads: [],
  options: {
    liberarAnexo: false,
    liberarAudio: false,
    liberarEmoji: false,
    liberarFoto: false,
    liberarVideo: false,
  },
};

export const reducers = createReducer(INITIAL_STATE, {
  [ActionTypes.SET]: (state, action: PayloadAction<IChatGroup[]>) => {
    const comMensagem = action.payload.filter((f) => !!f.idMensagem);
    const semMensagem = action.payload.filter((f) => !f.idMensagem);
    const mensagens = comMensagem.reduce((total, unread) => {
      return (unread.chats ?? []).length + total;
    }, 0);
    const chat = semMensagem.reduce((total, unread) => {
      return (unread.chats ?? []).length + total;
    }, 0);
    const geral = action.payload.reduce((total, unread) => {
      return (unread.chats ?? []).length + total;
    }, 0);
    return {
      ...state,
      unreads: action.payload,
      chat,
      geral,
      mensagens,
    };
  },
  [ActionTypes.SETOPTIONS]: (state, action: PayloadAction<IChatOptions>) => {
    return {
      ...state,
      options: action.payload,
    };
  },
});
